import { render, staticRenderFns } from "./rules-user.vue?vue&type=template&id=3a9906e0&scoped=true"
import script from "./rules-user.vue?vue&type=script&lang=js"
export * from "./rules-user.vue?vue&type=script&lang=js"
import style0 from "./rules-user.vue?vue&type=style&index=0&id=3a9906e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a9906e0",
  null
  
)

export default component.exports